// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1e0c1ule{display:block}\n._1q511ejb{padding-block-start:var(--ds-space-300,24px)}\n._85i5u2gc{padding-block-end:var(--ds-space-100,8px)}\n._bozgu2gc{padding-inline-start:var(--ds-space-100,8px)}\n._y4tiu2gc{padding-inline-end:var(--ds-space-100,8px)}", ""]);
// Exports
module.exports = exports;
